import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import "../css/cd.css";
import AdNav from "../components/adNav";
import Time from "../components/time";
import { useNavigate } from "react-router-dom";

const API_BASE =
  import.meta.env?.VITE_API_BASE ||
  process.env.REACT_APP_API_BASE ||
  "https://rfs2.infraconsoft.net.in/api";
const API_ORIGIN = API_BASE.replace(/\/api\/?$/, "");

const Company_details = () => {
  const navigate = useNavigate();

  const [details, setDetails] = useState({
    company_name: "N/A",
    contact_name: "N/A",
    email: "N/A",
    address: "N/A",
    username: "N/A",
    logo_path: "/media/tenants/infra_plesk/logo.png",
    phone: "N/A",
    id: undefined,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [form, setForm] = useState(details);

  const logoUrl = useMemo(() => {
    if (!details.logo_path) return "";
    if (/^https?:\/\//i.test(details.logo_path)) return details.logo_path;
    return `${API_ORIGIN}${details.logo_path}`;
  }, [details.logo_path]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setError("");
      try {
        const res = await axios.get(`${API_BASE}/cd`);
        const row = res.data?.company_details?.[0];
        if (row) {
          const mapped = {
            company_name: row.company_name || "N/A",
            contact_name: row.contact_name || "N/A",
            email: row.email || "N/A",
            address: row.address || "N/A",
            username: row.username || "N/A",
            logo_path: row.logo_path || "/media/tenants/infra_plesk/logo.png",
            phone: row.phone || "N/A",
            id: row.id,
          };
          setDetails(mapped);
          setForm(mapped);
        }
      } catch {
        setError("Failed to load company details.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const toggleEdit = () => {
    setForm(details);
    setIsEdit((v) => !v);
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    try {
      await axios.put(`${API_BASE}/cd_update`, { ...form });
      setDetails(form);
      setIsEdit(false);
    } catch {
      setError("Failed to save changes.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="cd_shell" id="admin-container">
      <AdNav />

      {/* Right Pane */}
      <div className="content-right">
        <div className="cd_main">

          {/* Top Bar */}
          <div className="cd_topbar">
            <div className="cd_topbar_left">
              <button
                className="cd_back"
                onClick={() => navigate(-1)}
                aria-label="Go back"
              >
                <i className="fa-solid fa-arrow-left"></i>
              </button>
              <h2 className="cd_pageTitle">Company Details</h2>
            </div>

            <div className="cd_topbar_right">
              <Time />
              {!isEdit && (
                <button
                  className="cd_btn cd_btn--primary"
                  onClick={toggleEdit}
                  aria-label="Edit"
                >
                  <i className="fa-solid fa-pen-to-square"></i>
                  <span>Edit</span>
                </button>
              )}
            </div>
          </div>

          {/* HERO — Brand → Logo → Greeting */}
          <section className="cd_hero cd_hero--brand">
  <h1 className="cd_brand">{details.company_name}</h1>

  <div className="cd_logoWrap">
    {logoUrl ? (
      <img
        className="cd_logo"
        src={logoUrl}
        alt="Company Logo"
        onError={(e) => (e.currentTarget.style.display = "none")}
      />
    ) : (
      <div className="cd_logoFallback">Logo</div>
    )}
  </div>

  <p className="cd_greeting">Welcome {details.contact_name}.</p>
</section>

          {/* DETAILS PANEL */}
          <section className="cd_panel">
            {loading ? (
              <div className="cd_state">Loading…</div>
            ) : error ? (
              <div className="cd_state cd_state--error">{error}</div>
            ) : !isEdit ? (
              <div className="cd_grid">
                <div className="cd_field">
                  <label className="cd_label">Admin Name</label>
                  <div className="cd_value">{details.contact_name}</div>
                </div>
                <div className="cd_field">
                  <label className="cd_label">User Name</label>
                  <div className="cd_value">{details.username}</div>
                </div>
                <div className="cd_field">
                  <label className="cd_label">Phone</label>
                  <div className="cd_value">{details.phone}</div>
                </div>
                <div className="cd_field">
                  <label className="cd_label">Email</label>
                  <div className="cd_value">{details.email}</div>
                </div>
                <div className="cd_field cd_field--span2">
                  <label className="cd_label">Address</label>
                  <div className="cd_value">{details.address}</div>
                </div>
              </div>
            ) : (
              <form className="cd_form" onSubmit={onSubmit}>
                <div className="cd_grid">
                  <div className="cd_control">
                    <label className="cd_label">Company Name</label>
                    <input
                      className="cd_input"
                      name="company_name"
                      value={form.company_name}
                      onChange={onChange}
                      required
                    />
                  </div>
                  <div className="cd_control">
                    <label className="cd_label">Admin Name</label>
                    <input
                      className="cd_input"
                      name="contact_name"
                      value={form.contact_name}
                      onChange={onChange}
                      required
                    />
                  </div>
                  <div className="cd_control">
                    <label className="cd_label">User Name</label>
                    <input
                      className="cd_input"
                      name="username"
                      value={form.username}
                      onChange={onChange}
                      required
                    />
                  </div>
                  <div className="cd_control">
                    <label className="cd_label">Phone</label>
                    <input
                      className="cd_input"
                      name="phone"
                      value={form.phone}
                      onChange={onChange}
                    />
                  </div>
                  <div className="cd_control">
                    <label className="cd_label">Email</label>
                    <input
                      className="cd_input"
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={onChange}
                    />
                  </div>
                 
                  <div className="cd_control cd_control--span2">
                    <label className="cd_label">Address</label>
                    <textarea
                      className="cd_textarea"
                      rows={3}
                      name="address"
                      value={form.address}
                      onChange={onChange}
                    />
                  </div>
                </div>

                <div className="cd_actions">
                  <button
                    type="button"
                    className="cd_btn"
                    onClick={toggleEdit}
                    disabled={saving}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="cd_btn cd_btn--primary"
                    disabled={saving}
                  >
                    {saving ? "Saving…" : "Save Changes"}
                  </button>
                </div>
              </form>
            )}
          </section>
        </div>
      </div>
    </div>
  );
};

export default Company_details;
